// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-to-signup[data-v-3b7ce7dc]{display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%}.caption[data-v-3b7ce7dc]{font-size:18px}.c-btn[data-v-3b7ce7dc]{display:flex;justify-content:center;align-items:center}", ""]);
// Exports
module.exports = exports;
